// src/api/http.js
import axios from 'axios';

const API_ORIGIN = import.meta.env.VITE_API_ORIGIN || 'http://localhost:8000';
const API_URL = import.meta.env.VITE_API_URL || `${API_ORIGIN}/api`;

// Para endpoints API (/api/...)
export const http = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { Accept: 'application/json' },
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN'
});

// Para auth (/sanctum/csrf-cookie y /api/login)
export const authHttp = axios.create({
  baseURL: API_ORIGIN,
  withCredentials: true,
  headers: { Accept: 'application/json' },
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN'
});

let csrfReady = false;
export async function ensureCsrf() {
  if (csrfReady) return;
  await authHttp.get('/sanctum/csrf-cookie'); // <-- SETEA cookie XSRF-TOKEN
  csrfReady = true;
}

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(name + '='))
    ?.split('=')[1];
}

http.interceptors.request.use((config) => {
  // Fuerza el header en cada request hacia la API
  const raw = getCookie('XSRF-TOKEN');
  if (raw) {
    try {
      // Laravel espera el valor decodificado
      config.headers['X-XSRF-TOKEN'] = decodeURIComponent(raw);
    } catch {
      config.headers['X-XSRF-TOKEN'] = raw;
    }
  }
  return config;
});